import { withSvgIcon } from './withSvgIcon';

export const UpdateIcon = withSvgIcon(
  <>
    <path d="M3.66016 7.42569C4.68669 4.99754 7.08194 3.2998 9.87859 3.2998C13.6097 3.2998 16.63 6.32019 16.63 10.0512" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M18.8541 7.28711L16.7554 9.89505C16.6861 9.9811 16.5602 9.99472 16.4741 9.92547L13.8662 7.8267" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M16.1623 12.6431C15.1357 15.0647 12.7405 16.769 9.94383 16.769C6.21277 16.769 3.19238 13.7486 3.19238 10.0176" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M1.10059 12.8866L3.07528 10.1792C3.14037 10.0899 3.26548 10.0703 3.35473 10.1354L6.06217 12.1101" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
  </>,
  { viewBox: '0 0 20 20' },
);
